document.addEventListener("DOMContentLoaded", function() {
    let randomizerAudio = document.getElementById("audioPlayer");
    let clappingAudio = document.getElementById("clappingAudio");
    let startSpin = document.getElementById("startSpin");
    let showResult = document.getElementById("showResult");

    if (randomizerAudio) {
        if (startSpin) {
            startSpin.addEventListener("click", function() {
                if (randomizerAudio.paused) {
                    randomizerAudio.play().catch(error => console.error("Randomizer Audio Error:", error));
                }
            });
        }

        if (showResult) {
            showResult.addEventListener("click", function() {
                randomizerAudio.pause();
                randomizerAudio.currentTime = 0;

                if (clappingAudio) {
                    clappingAudio.play()
                }
            });
        }
    }
});